import { useQuery } from '@tanstack/react-query'
import { analyticsApi } from 'src/services/analyticsApi'

export interface TopicBreakdownItem {
  id: string
  name: string
  negative: number
  neutral: number
  positive: number
  total: number
}

export interface TopicBreakdownParent extends TopicBreakdownItem {
  children: TopicBreakdownItem[]
}

export interface TopicBreakdownResponse {
  topics: TopicBreakdownParent[]
}

interface UseGetTopicBreakdownParams {
  fromDate?: string
  pageId: string
  platforms?: string[]
  toDate?: string
}

export const useGetTopicBreakdownQuery = (
  params: UseGetTopicBreakdownParams
) => {
  return useQuery<TopicBreakdownResponse | null>({
    enabled: !!params.pageId,
    queryFn: async () => {
      const { data } = await analyticsApi().get<TopicBreakdownResponse>(
        '/v1_private/inbox-analysis/topic-breakdown',
        {
          params: {
            fromDate: params.fromDate,
            pageId: params.pageId,
            platforms: params.platforms?.length
              ? params.platforms.join(',')
              : undefined,
            toDate: params.toDate,
          },
        }
      )
      return data
    },
    queryKey: [
      'inbox-topic-breakdown',
      params.pageId,
      params.fromDate,
      params.toDate,
      params.platforms,
    ],
  })
}
